import React from "react";

import heroImg from "../../assets/attt.png";
import foodImg from "../../assets/heroSecImg.jpg";
import panGraphics from "../../assets/panGraphics.png";
import { useLocation, useNavigate } from "react-router-dom";

const HeroSection = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <section
      className="w-full px-6 md:px-[10%] pt-5 pb-20 relative overflow-hidden"
      data-aos="fade-up"
    >
      {/* Pan graphic */}
      <img
        src={panGraphics}
        alt="Pan Illustration"
        className="absolute top-0 left-0 w-28 md:w-40 lg:w-60 opacity-90 hidden md:block z-40"
        data-aos="fade-down-right"
        data-aos-delay="200"
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-24 md:gap-8 items-end relative">
        {/* Left text block */}
        <div
          className="md:col-span-1 flex flex-col justify-end space-y-4"
          data-aos="fade-right"
        >
          <p className="text-sm font-semibold tracking-wider text-[#4E5C36] favela">
            YOUR EVENING
          </p>

          <h1
            className="text-lg lg:text-3xl leading-snug text-gray-900 hidden md:block"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Arrive Elegantly.
            <br /> Watch it made. <br /> Eat with intent. <br />
            Stay for the conversation
          </h1>

          <h1
            className="text-lg font-medium leading-snug text-gray-900 block md:hidden w-[100%]"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Arrive Elegantly.
            <br /> Watch it made. <br /> Eat with intent. <br />
            Stay for the conversation
          </h1>
        </div>

        {/* Right image block */}
        <div
          className="md:col-span-2 relative w-full h-full"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          <img
            src={foodImg}
            alt="Delicious food"
            className="w-full max-h-[80vh] object-cover rounded-2xl"
          />

          {/* Button */}
          <button
            onClick={() => {
              if (pathname !== "/") {
                navigate("/", { state: { scrollTo: "tickets" } });
              } else {
                document
                  .getElementById("tickets")
                  ?.scrollIntoView({ behavior: "smooth" });
              }
            }}
            className="absolute bottom-6 right-6 bg-[#4E5C36] text-white px-6 py-3 rounded-full flex items-center gap-2 shadow-lg transition"
            data-aos="fade-left"
            data-aos-delay="600"
          >
            <span>Join The Table</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </button>
        </div>

        {/* “A Tailored Taste” graphic */}
        <div
          className="absolute top-[30%] md:top-[0%] left-1/3 md:left-[10%] w-[70%] md:w-[45%] bg-[#fff] p-5 rounded-lg rounded-t-none"
          data-aos="fade-up"
          data-aos-delay="800"
        >
          <img
            src={heroImg}
            alt="A Tailored Taste"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
